import styled, { css } from "styled-components";

import ToggleUp from "images/sports/common/toggle_up.svg";
import ToggleUpOn from "images/sports/common/toggle_up_on.svg";
import ToggleDown from "images/sports/common/toggle_down.svg";
import ToggleDownOn from "images/sports/common/toggle_down_on.svg";

export const Container = styled.div`
  width: calc(100% - 60px);
  padding: 0px 30px 40px 30px;
  background: #fff;
`;

export const Title = styled.p`
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: GmarketSansMedium, sans-serif;
  font-size: 22px;

  & > span {
    margin-left: auto;
    font-family: Gulim, sans-serif;
    font-size: 12px;
    color: #757575;
  }
`;

export const ToggleButton = styled.div`
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  margin-left: auto;
  width: 13px;
  height: 9px;

  &:hover {
    background: url(${(props) => (props.viewSub ? ToggleUpOn : ToggleDownOn)})
      no-repeat center center;
  }
  background: url(${(props) => (props.viewSub ? ToggleUp : ToggleDown)})
    no-repeat center center;
`;

export const Table = styled.table`
  border-collapse: collapse;
  margin-top: 20px;

  border: 1px solid #e3e3e3;
  & > thead th {
    height: 48px;
    text-align: center;
    background: #fafafa;
    border-bottom: 1px solid #e3e3e3;
  }

  & > tbody > tr td:first-child {
    text-align: center;
  }
  & tr:not(.subRow):hover ${ToggleButton} {
    background: url(${ToggleDownOn}) no-repeat center center;
  }
  & tr.on:not(.subRow):hover ${ToggleButton} {
    background: url(${ToggleUpOn}) no-repeat center center;
  }

  & > tbody > tr:not(.subRow) td {
    height: 62px;
  }
  & > tbody td.winner {
    color: #ee1a21;
  }

  & > tbody > tr {
    border-bottom: 1px solid rgb(236, 239, 243);
  }
  & > tbody > tr:last-child {
    border-bottom: none;
  }
  & > tbody > tr:not(.subRow) {
    cursor: pointer;
  }

  & > tbody > tr > td:nth-child(4) {
    font-family: tahoma, "돋움", Dotum, -apple-system, SF Pro Display,
      Helvetica Neue, Apple SD Gothic Neo, Malgun Gothic,
      "\B9D1\C740   \ACE0\B515", sans-serif;
    font-size: 18px;
    text-align: center;
  }
  & > tbody > tr > td:nth-child(3) {
    font-family: tahoma, "돋움", Dotum, -apple-system, SF Pro Display,
      Helvetica Neue, Apple SD Gothic Neo, Malgun Gothic,
      "\B9D1\C740   \ACE0\B515", sans-serif;
    font-size: 18px;
    text-align: right;
  }
  & > tbody > tr > td:nth-child(5) {
    font-family: tahoma, "돋움", Dotum, -apple-system, SF Pro Display,
      Helvetica Neue, Apple SD Gothic Neo, Malgun Gothic,
      "\B9D1\C740   \ACE0\B515", sans-serif;
    font-size: 18px;
    text-align: left;
  }

  & > tbody > tr > td:nth-child(2) {
    text-align: right;
    text-indent: -10px;
    padding-right: 10px;
  }
  & > tbody > tr > td:nth-child(6) {
    text-align: left;
    text-indent: 10px;
    padding-left: 10px;
  }

  & > tbody > tr > td:nth-child(7) {
    text-align: left;
    position: relative;
  }
`;

export const SubRow = styled.tr`
  background: #f4f2f4;
  & > td {
    height: auto;
    padding: 10px;
  }
`;

export const SubTable = styled.table`
  border-collapse: collapse;
  border: 1px solid #d1d1d1;
  table-layout: fixed;
  width: 100%;

  background: #fff;
  & > thead th {
    height: 30px;
    background: #fafafa;
    border-bottom: 1px solid #d1d1d1;
    &:not(:last-child) {
      border-right: 1px solid #e3e3e3;
    }
  }

  & > tbody td {
    border: 1px solid #e3e3e3;
    height: 30px;
  }

  & > tbody th {
    text-align: left;
    border: 1px solid #e3e3e3;
    padding-left: 10px;
  }

  & > tfoot td {
    border: 1px solid #e3e3e3;
    height: 30px;
  }
`;

export const ResultBadge = styled.span`
  display: inline-block;
  width: 43px;
  height: 18px;
  vertical-align: middle;
  text-align: center;
  line-height: 20px;
  border: 1px solid transparent;
  border-radius: 10px;
  background: #fff;
  font-size: 11px;
  font-family: "돋움", "Dotum", sans-serif;
  letter-spacing: -1px;
  &:not(:last-child) {
    margin-right: 4px;
  }
  ${(props) =>
    props.position === "home"
      ? css`
          color: #ee1a21;
          border-color: #ee1a21;
        `
      : css`
          color: #2a83ff;
          border-color: #2a83ff;
        `}
`;
